import { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { IGeneralSettings } from '../models/generalSettingsModel';
import { IMapConfiguration } from '../models/mapConfigurationModel';

export interface testServerUrlProps {
  url: string;
  username?: string;
  password?: string;
  token?: string;
  getServiceList: boolean;
}

export interface IConfigurationState {
  generalSettings: IGeneralSettings;
  mapConfiguration: IMapConfiguration;
  getLocatorSuggestions: (request: string) => Promise<any>;
  getProxyUrl: () => string;
  testServerUrl: (server: testServerUrlProps, tenantId?: string) => Promise<void>;
}

export function createCtx<A extends {} | null>() {
  const ctx = createContext<A | undefined>(undefined);

  function useCtx() {
    const [t] = useTranslation('geosecma-settings');
    const c = useContext(ctx);

    if (c === undefined) {
      throw new Error(t('useContext'));
    }

    return c;
  }

  return [useCtx, ctx.Provider] as const;
}

export const [useConfigurationCtx, ConfigurationCtxProvider] = createCtx<IConfigurationState>();
